export const AdditionalInfoPageContentSv = () => {
  return (
    <>
      <h2>Innehåll</h2>
      <p>
        Informationen i tjänsten är från Europeiska miljöbyråns (EEA){' '}
        <a
          href="https://www.eea.europa.eu/data-and-maps/data/industrial-reporting-under-the-industrial-3"
          target="blank">
          {' '}
          PRTR-databas
        </a>{' '}
        . Databasen innehåller uppgifter om PRTR-anläggningarnas utsläpp till
        luft och vatten samt om avfallstransporter för de följande verksamheter:
      </p>
      <ul>
        <li>Energisektorn</li>
        <li>Produktion och behandling av mataller</li>
        <li>Mineralindustri</li>
        <li>Kemisk industri</li>
        <li>Avfallshantering och avloppsvattenrening</li>
        <li>Papper och trävaror</li>
        <li>Djurhållning och fiskodling</li>
        <li>Livsmedelstillverkning</li>
        <li>Annan verksamhet</li>
      </ul>
      <p>
        Anläggningarna är rapporteringsskyldiga när utsläppen överskrider
        kapacitet eller ämnespecifika tröskelvärden.Utsläppen innehåller också
        undantagssituationer t.ex.störningar i processen eller i
        reningsteknik.Registret innehåller inte småskalig industri eller diffusa
        utsläpp som trafik eller hushåll.
      </p>
      <p>
        Koldioksidutsläppen presenteras som summan av fossil och biogen CO2 samt
        som fossil koldioksid.Sökningen  <i>koldioksid ( exkl. biogen)</i> ger
        utsläpp av fossil CO2, som härstammar från förbränning av fossila
        bränslen. Biogen CO2, som härstammar från förbränning av biomassa ingår
        inte i internationella reduktionsförpliktelser (t.ex.
        klimatkonventionen).
      </p>
      <p>
        Anläggningarna rapporterar årligen utsläppen till luft och vatten,
        gällande 91 ämnen i PRTR protokollets bilaga 5 ifall dessa överskrider
        gränsvärden, samt uppgifter om avfallstransporter.Utsläpp till mark
        ingår inte i rapporteringen (inte tillåtna i Finland).Finska
        anläggningar rapporterar avfallstransporter enligt Europeiska
        avfallskatalogen.I andra länder kan man alternativt rapportera
        kemikalier i avfall samt, ytterligare till bilaga 5, kan man nationellt
        välja att raportera utsläpp av andra ämnen.Registern innehåller 65
        verksamheter.
      </p>{' '}
      Sektorsspecifika BREF-dokument om bästa tillgängliga teknik (Best
      Available Techniques Reference Document) finns på miljöförvaltningens
      nätsida
      <a href="https://www.ymparisto.fi/fi-fi/kulutus_ja_tuotanto/paras_tekniikka_bat/vertailuasiakirjat">
        Vertailuasiakirjat
      </a>
      .
      <p>
        Ofta visas i utsläppsregister information om diffusa källor,  som
        exempelvis trafik, jordbruk och användning av produkter.   Uppgifter om
        diffusa luftutsläpp finns på miljöförvaltningens nätsida
        <a href="https://www.environment.fi/en-US/Forms_permits_and_environmental_impact_assessment/Reporting/PRTR_Nonpoint_source_emissions">
          {' '}
          på miljöförvaltningens nätsidor
        </a>
        .{' '}
      </p>
       <h2>En kort historia om utsläppsregister</h2>
      <p>
        Tillgång till miljöinformation ingick redan i Riodeklarationen år 1992.
         FN:s ekonomikomissionens konvention om tillgång till information,
        allmänhetens deltagande i beslutsprocesser och tillgång till rättslig
        prövning i miljöfrågor (Århuskonventionen) trädde i kraft år 1998.
        Allmänheten skall ha öppet tillgång till miljöInformation både på
        begäran och genom aktiv spridning, t.ex. elektronisk tillgänglig och på
        nationella språk. Information skall presenteras om hälso- eller
        miljöfarliga utsläpp som begränsas genom lagstiftning och som
        verksamhetsidkaren skall övervaka. Konventionen trädde i kraft år 2001,
        när 17 länder, främst östeuropeiska ock mellanöstiska, hade ratificerat
        den. Finland undertecknade Århuskonventionen i 1998 och ratificerade den
        i 2004, när konventionen också trädde i kraft i Finland – dock fyllde
        Finlands lagstiftning konventionens krav redan tidigare. EU
        undertecknade avtalet 1998 och ratificerade den år 2005.  For tillfället
        har ca 50 länder ratificerat eller undertecknat avtalet{' '}
        <a
          href="https://treaties.un.org/Pages/ViewDetails.aspx?src=IND&mtdsg_no=XXVII-13&chapter=27&clang=_en#1"
          target="blank">
          ...
        </a>
        . 
      </p>
      <p>
        {' '}
        Kievprotokollet under Århuskonventionen är det första juridiskt bindande
        internationellt dokument om registerar över utsläpp och överföringar av
        föroreningar (Pollutant Release and Transfer Register, PRTR) med syftet
        att förbättra tillgängligheten av miljöinformation bl.a. genom enhetligt
        formade nationella register och att tillåta företagen visa miljömedveten
        agerande när de övervakar sina utsläpp. Finland undertecknade
        Kievprotokollet å3 2003 (samma år som EU) och ratificerade den år 2009,
        EU år 2006.  
      </p>
      <p>
        {' '}
        Utgående från industriutsläppsdirektivet (samordnade åtgärder för att
        förebygga och begränsa föroreningar) etablerade EU Europeiska
        utsläppsregistret (European Pollutant Emission Register, EPER) år 2000.
        Efterträdaren av EPER, dvs. register över utsläpp och överföringar av
        föroreningar (European Pollutant Release and Transfer Register E-PRTR)
        bildades år 2006. Uppgifter om finländska anläggningar har rapporterats
        till båda register från första början. Sedan 2021 är uppgifterna
        tillgängliga i  
        <a href="https://industry.eea.europa.eu/" target="blank">
          industriutsläppsportal
        </a>{' '}
        som administreras av EEA.
      </p>
      <p>
        <a
          href="https://unece.org/DAM/env/pp/documents/ACtext/Aarhus_Convention_text_Swedish.pdf"
          target="blank">
          Århuskonventionen
        </a>
        &nbsp;(pdf 50 kt)
      </p>
      <p>
        <a
          href="https://ec.europa.eu/environment/industry/stationary/e-prtr/pdf/sv_prtr.pdf"
          target="blank">
          Rådets beslut PRTR
        </a>
        &nbsp;(pdf 115 kt)
      </p>
      <h2>Miljötillstånd</h2>
      <p>
        Verksamhet som orsakar miljöföroreningar kräver miljötillstånd enligt
        miljöskyddslagen. Man kan söka Miljötillstånden för de anläggningar som
        presenteras i denna websida från{' '}
        <a href="https://ytietopalvelu.lvv.fi/sv-FI" target="blank">
          Informationstjänsten för miljöärenden av Tillstånds- och
          tillsynsverket
        </a>
        .
      </p>
      <h2>Bästa tillgängliga teknik</h2>
      <p>
        Utsläppsgränsvärden, övervakning och andra tillståndsvillkor för
        anläggningar som omfattas av tillämpningsområdet för direktivet om
        industriutsläpp baserar sig på bästa tillgängliga teknik. Med det avses
        så effektiva och utvecklade, tekniskt och ekonomiskt genomförbara
        produktions- och reningsmetoder som möjligt samt sådana sätt att
        planera, bygga, underhålla, driva och upphöra med verksamheten som kan
        förebygga eller effektivast minska den förorening av miljön som
        verksamheten orsakar och som lämpar sig som grund för
        miljötillståndsvillkoren. Som ett resultat av det informationsutbyte
        mellan industrin och myndigheterna som organiseras av Europeiska
        kommissionen publiceras BAT-referensdokument och BAT-slutsatser som är
        bindande för medlemsländerna. Referensdokumenten och BAT-slutsatserna
        finns på{' '}
        <a href="https://eippcb.jrc.ec.europa.eu/reference" target="blank">
          Europeiska IPPC-byråns webbplats
        </a>
        . Mer information finns på{' '}
        <a
          href="https://www.ymparisto.fi/sv/hallbar-cirkular-ekonomi-och-bioekonomi/hallbar-produktion/basta-tillgangliga-teknik-bat"
          target="blank">
          Finlands miljöcentrals webbplats
        </a>
        .
      </p>
      <h2>Uppgifter om servicen</h2>
      <p>
        Finlands miljöcentral har förverkligat webbsidan enligt uppdrag av
        miljöministeriet. Respons om uppgifterna och annat innehåll kan skickas
        till  övervakningsmyndigheter (
        <a href="https://lvv.fi/sv/miljo" target="blank">
          Tillstånds -och tillsynsverket
        </a>
        ). Respons om sidornas tekniska funktioner eller förbättringsförslag kan
        skickas till <a href="mailto:PRTR@syke.fi">PRTR@syke.fi</a>.
      </p>
      <p>
        <a href="Käyttöehdot.pdf" target="blank">
          Användningsvillkor
        </a>
      </p>
      <p>
        <a href="Palveluseloste.pdf" target="blank">
          Service proxy
        </a>
      </p>
    </>
  )
}
